<template>
  <div class="mt-4 print:hidden">
    <a v-for="locale in locales"
       v-bind:key="locale"
       :href="'/'+locale"
       class="inline-block bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow m-2">
      <flag :iso="getCountry(locale)"></flag>
    </a>
  </div>
</template>

<script>

export default {
  name: "language-switch",

  data: function () {
    return {
      locales: ["bg", "cn", "cz", "de", "dk", "ee", "en", "es", "fr", "gr", "hu", "is", "it", "ja", "lt", "lu", "lv", "nl", "no", "pl", "pt", "rs", "ru", "se", "sk", "tr", "ua", "vn"]
    }
  },
  created() {
    this.setHrefLangMetaTags();
  },
  methods: {
    switchLocale(locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale;

      }
    },
    getCountry(locale) {
      switch (locale) {
        case 'en':
          return 'gb';
        case 'ja':
          return 'jp';
        default:
          return locale;
      }
    },
    setHrefLangMetaTags() {
      for(let i in this.locales){
        let langhref = document.createElement("link");
        langhref.setAttribute("rel", "alternate");
        langhref.setAttribute("href", "/"+this.locales[i]);
        langhref.setAttribute("hreflang", this.locales[i]);

        document.head.append(langhref);
      }
    }

  }
}
</script>

<style scoped>

</style>